import React, {useEffect, useRef} from 'react';
import cn from 'classnames';

import {
	useDebouncedCallback,
	useDebouncedValue,
	useScrollThreshold,
	useSearchMgrInstance
} from 'coreHooks';
import {useCategory} from 'coreHooks/categories';

import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';
import TotalProducts from 'brandComponents/TotalProducts';
import Typography from 'brandComponents/Typography';

import styles from './ProductListHeading.module.scss';

const ProductListHeading = () => {
	const {searchType, searchInstanceKey, cgid, initialPage} = useCategoryContext(true) || {};
	const searchMgr = useSearchMgrInstance({
		searchType,
		key: searchInstanceKey,
	});
	const pageNumber = searchMgr.getPageNumber() || initialPage;
	const searchModel = searchMgr.getStoredSearchModel();
	const categoryModel = useCategory(cgid);
	const totalItems = searchModel?.getTotalProductsNumber();
	const ref = useRef(null);
	const isScrolled = useDebouncedValue(useScrollThreshold(10), 50);

	const updateHeight = () => {
		let height = 'auto';

		if (ref.current) {
			height = `${ref.current.offsetHeight}px`;
		}

		document.body.style.setProperty('--plp-heading-height', height);
	};

	const debouncedUpdateTitleHeight = useDebouncedCallback(updateHeight, 200);

	useEffect(() => {
		updateHeight(); // Calculate the height initially
		window.addEventListener('resize', debouncedUpdateTitleHeight);

		return () => {
			window.removeEventListener('resize', debouncedUpdateTitleHeight);
			debouncedUpdateTitleHeight.cancel();
		};
	}, []);

	return (
		<div className={cn(styles['product-list_heading__wrapper'], {
			[styles['product-list_heading__wrapper_show']]: pageNumber === 1 && !isScrolled
		})} ref={ref}>
			<div className={cn(styles['product-list_heading'], 'product-list_heading')}>
				<div className={styles['product-list_heading-title']}>
					<Typography variant="h1">
						{categoryModel?.getPlpPageTitle() || categoryModel?.getName()}
					</Typography>
					<TotalProducts total={totalItems} />
				</div>
			</div>
			<Typography variant="p" classNames={cn(
				styles['product-list_description'],
				'product-list_description', {
					[styles['product-list_description_show']]: pageNumber === 1 && !isScrolled
				}
			)}>
				{categoryModel?.getCategoryDescription()}
			</Typography>
		</div>
	);
};

export default ProductListHeading;
